// Cache once per page so repeated calls are free
let __cachedPostId = null;

/**
 * Best-effort current post/page ID.
 * Returns a number (>=1) or 0 when not applicable (archives, 404, etc.).
 */
export function get_current_post_id() {
	if (__cachedPostId !== null) return __cachedPostId;

	// Get post id from body data attribute
	const dataId = document?.body?.dataset?.postId;

	if (dataId) {
		__cachedPostId = parseInt(dataId, 10) || 0;
	return __cachedPostId;
	}

	__cachedPostId = 0;
	return __cachedPostId;
}